import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormControl, Validators } from '@angular/forms';
import { Authentication } from '../../services/authentication.service';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { NotificationService } from '../../services/notification.service';
import { AccountService } from '../../services/account.service';
import { TitleService } from '../../services/title.service';
import { QueryParamService } from '../../services/query-param.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  userName: any;
  password: any = '';
  valid = true;
  verified: any;
  validEmail = true;
  token: any;
  refreshToken: any;
  userId: any;

  noAccount = false;
  emailExist = false;
  emailVerified = false;

  emailFC = new FormControl('', [Validators.required]);
  passwordFC = new FormControl('', [Validators.required]);

  constructor(
    private authService: Authentication,
    private accountService: AccountService,
    private router: Router,
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private errorHandlingService: ErrorHandlingService,
    private notificationService: NotificationService,
    private titleService: TitleService,
    private queryParamService: QueryParamService,
  ) {
    if (this.authService.isTokenValid()) {
      this.router.navigate(['dashboard']);
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.route.snapshot, this.router.routerState.snapshot);
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.refreshToken = this.route.snapshot.queryParamMap.get('refresh_token');
    this.userId = this.route.snapshot.queryParamMap.get('userId');

    if (this.token && this.userId && this.refreshToken) {
      this.socialAuthenticate();
    } else {
      this.userName = this.route.snapshot.queryParamMap.get('username');
      this.emailFC.setValue(this.userName);
      this.verified = this.route.snapshot.queryParamMap.get('verified');
    }

    const usr = this.queryParamService.getQueryParam('user');
    const pass = this.queryParamService.getQueryParam('pass');
    this.queryParamService.storeQueryParam('user', '', false);
    this.queryParamService.storeQueryParam('pass', '', false);
    if (usr !== null && pass !== null) {
      this.ngxLoader.start();
      //in query params + is interpreted as a space. we don't allow space in usernames
      this.authService.login(usr.replace(' ', '+').toLowerCase(), pass).subscribe(
        (response) => {
          this.authService.successAuthentication(response);
        },
        (error) => {
          this.authService.errorAuthentication(error);
        },
      );
    }
  }

  onSubmit(): any {
    this.userName = this.emailFC.value;
    this.password = this.passwordFC.value;
    if (this.userName === '' || this.userName === undefined || this.userName === null) {
      this.errorHandlingService.showError('User Name can not be empty');
      return;
    }
    if (this.password === '' || this.password === undefined || this.password === null) {
      this.errorHandlingService.showError('Password can not be empty');
      return;
    }
    this.ngxLoader.start();
    this.authService.login(this.userName.toLowerCase(), this.password).subscribe(
      (response) => {
        this.authService.successAuthentication(response);
      },
      (error) => {
        this.authService.errorAuthentication(error);
        if (error.status === 417) {
          this.noAccount = false;
          this.emailExist = true;
          this.emailVerified = false;
        }
        if (error.status === 401) {
          this.noAccount = true;
          this.emailExist = false;
          this.emailVerified = false;
        }
      },
    );
  }

  validateEmail() {
    this.noAccount = false;
    this.emailExist = false;
    this.emailVerified = false;
  }

  verifyEmail() {
    /* eslint-disable-next-line */
    if (/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(this.userName)) {
      this.validEmail = true;
    } else {
      this.validEmail = false;
    }
    this.validateEmail();
  }

  resendVerificationEmail(): any {
    this.ngxLoader.start();
    this.accountService.resendVerificationEmail(this.userName.toLowerCase()).subscribe(
      (data) => {
        this.ngxLoader.stop();
        this.notificationService.showSuccess(`Verification email resent to ${this.userName}`);
      },
      (err) => {
        this.ngxLoader.stop();
        return this.errorHandlingService.handleError(err, err.url);
      },
    );
  }

  resetPassword(): any {
    this.ngxLoader.start();
    this.accountService.reset(this.userName.toLowerCase()).subscribe(
      (data) => {
        this.ngxLoader.stop();
        this.notificationService.showSuccess(`Verification email resent to ${this.userName}`);
      },
      (err) => {
        this.ngxLoader.stop();
        this.errorHandlingService.handleError(err, err.url);
        if (err.error.status === 417) {
          this.valid = false;
        }
      },
    );
  }

  googleLogin() {
    this.authService.loginWithGoogle().subscribe(
      (data: any) => {
        if (data && data.body) {
          location.href = data.body;
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.errorHandlingService.handleError(error, error.url);
      },
    );
  }

  microsoftLogin() {
    this.authService.loginWithMicrosoft().subscribe(
      (data: any) => {
        if (data && data.body) {
          location.href = data.body;
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.errorHandlingService.handleError(error, error.url);
      },
    );
  }

  socialAuthenticate() {
    localStorage.setItem('access_token', this.token);
    localStorage.setItem('refresh_token', this.refreshToken);

    this.authService.successAuthentication({ access_token: this.token, refresh_token: this.refreshToken });
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com';
  }
}
